import { withChildren } from '@builder.io/react';
import { BACKGROUND_COLORS } from '../../../shared/colors';
import { TYPES_LEAD_IMAGE } from '../../../shared/constants';
import { BuilderConfig } from '../../../types/Builder';
import HeroMoneyFlowPage, { Props } from './hero-money-flow-page';
const HeroMoneyFlowPageWidthChildren = withChildren(HeroMoneyFlowPage);
export const MoneyFlowHeroBuilderConfig = {
  name: 'Category Hero',
  inputs: [
    {
      name: 'title',
      type: 'string',
      required: true,
    },

    {
      name: 'leadImages',
      type: 'list',
      defaultValue: [],
      subFields: [
        {
          name: 'imageUrl',
          type: 'file',
          defaultValue: '',
          allowedFileTypes: ['png', 'jpeg'],
        },
        {
          name: 'imageHref',
          type: 'string',
          defaultValue: '',
        },
        {
          name: 'colorless',
          type: 'boolean',
          defaultValue: false,
        },
        {
          name: 'type',
          type: 'string',
          enum: Object.values(TYPES_LEAD_IMAGE),
          defaultValue: TYPES_LEAD_IMAGE.IMAGE,
        },
        {
          name: 'videoUrl',
          type: 'file',
          defaultValue: '',
          allowedFileTypes: ['mp4'],
        },
      ],
    },
    {
      name: 'backgroundColor',
      type: 'string',
      enum: Object.values(BACKGROUND_COLORS),
    },
    {
      name: 'introTitle',
      type: 'richText',
      required: true,
    },
    {
      name: 'introDescription',
      type: 'richText',
      required: false,
    },
    {
      name: 'borderRadius',
      type: 'number',
      required: false,
    },
  ],
};

const builderConfig: BuilderConfig<Props> = {
  component: HeroMoneyFlowPageWidthChildren,
  config: MoneyFlowHeroBuilderConfig,
};

export default builderConfig;
